import React from "react";
import PropTypes from "prop-types";
import { useNavigate, Link } from "react-router-dom";
import styles from "./Contact.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import ContactBox from "../../components/ContactBox";
import { StaticRoutes } from "../routes";

const Contact = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    /*{
      label: "LOG IN",
      options: [],
      border: false,
      path: StaticRoutes.Login,
    },*/
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  const navigate = useNavigate();

  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.pageContainer}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8 mb-2">
              <h2 className={styles.h2}>Contact Us</h2>
              <h5>
                Email us at{" "}
                <Link className={styles.link} to={"mailto:tech@bidpro.com"}>
                  tech@bidpro.com
                </Link>{" "}
                with any questions or concerns.
              </h5>
              <p>We'll get in touch with you as soon as possible.</p>
            </div>
            <div className="col-12 col-lg-4">
              <ContactBox />
            </div>
          </div>
        </div>
      </div>
      <Footer lists={footerLists} inverse={true} />
    </>
  );
};

Contact.propTypes = {
  navList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.array,
      border: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
    })
  ),
  footerLists: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          src: PropTypes.string,
        })
      ),
    })
  ),
};

export default Contact;
